<template>
  <div>
    <div class="pop_update pop_bege popup_wrap" style="display:block">
      <div class="popup_in">
        <div class="popup">
          <div class="popup_close stay_close close-animate">
            <a href="javascript:void(0);" @click.prevent="closePop">
              <close/>
            </a>
          </div>
          <div class="pop_frame">
            <h2 class="title25">רגע לפני שמתקדמים, טיפ קטן</h2>
            <p class="message">
              חלק מהמוצרים נמכרים
              <b>גם לפי משקל וגם ביחידות</b>,
               שימו לב שבחרתם את המידה הרצויה
            </p>
            <div class="preview">
              <div>זה נראה ככה:</div>
              <img src="/wp-content/themes/carmella/carmella-vue/src/assets/img/add-to-cart-animation.gif">
            </div>
            <a class="ok-close" href="javascript:void(0);" @click.prevent="closePop">תודה, הבנתי</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Close from "../../assets/img/close.svg";
import {mapState} from "vuex";

export default {
  methods: {
    closePop() {
      this.$modal.hide("weight-and-quantity");
    }
  },
  computed: {
    // ...mapState(["orderEdit", "orderEditMeta","permenantOrderEdit"]),
    // isPermenetOrder() {
    //   if (typeof this.permenantOrderEdit == 'object' && this.permenantOrderEdit) {
    //     return true;
    //   }
    //   return false;
    // }
  },
  components: {
    Close
  }
};
</script>

<style lang="sass" scoped>
.popup
  background: #FFD7D6 url(/wp-content/themes/carmella/carmella-vue/src/assets/img/popup-weight.jpg) no-repeat center
  max-width: 800px
  height: 600px
  top: 120px
  border-radius: 6px
  .pop_frame
    border: 0
    padding: 7em 5em 0 18em
    text-align: right
    .title25
      font-family: 'RaananCondensed'
      font-style: normal
      font-weight: 900
      font-size: 52px
      line-height: 54px
      color: #2B381D
    .message
      font-style: normal
      font-weight: 400
      font-size: 27px
      line-height: 30px
      color: #2B381D
      b
        color: #E33915
        font-weight: 900
    .preview
      margin: 30px 0
      font-size: 18px
    a.ok-close
      font-size: 16px
      text-decoration-line: underline
      color: #2B381D

@media (max-width: 480px)
  .popup
    background: #FFD7D6 url(/wp-content/themes/carmella/carmella-vue/src/assets/img/popup-weight-mobile.jpg) no-repeat bottom center / cover
    max-width: 90%
    height: 414px
    top: 22%
    .pop_frame
      padding: 20px
      text-align: center
      .title25
        font-size: 35px
        line-height: 37px
        letter-spacing: 0.05em
      .message
        font-size: 20px
        line-height: 24px
      .preview
        margin: 20px 0 7px
</style>